import React, { useContext } from "react";
import "./Solutions.css";
import { Context } from "../../../context/Context";
import { landingContent } from "../content/landingContent";

export const Solutions = () => {
  const { lang } = useContext(Context);
  const t = landingContent[lang] || landingContent.en;

  return (
    <section className="landing-solutions" id="solutions">
      <div className="landing-solutions-intro">
        <div className="landing-kicker">
          <span className="landing-kicker-dot" />
          {t.solutions.kicker}
        </div>
        <h2>{t.solutions.title}</h2>
        <p>{t.solutions.description}</p>
      </div>

      <div className="landing-solutions-grid">
        {t.solutions.items.map((item) => (
          <article
            className="landing-solution-card"
            key={item.num}
            data-index={item.num}
          >
            <div className="landing-solution-head">
              <div className="landing-solution-num">{item.num}</div>
              <h3>{item.title}</h3>
            </div>
            <p>{item.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Solutions;
